import { OCR_CONSTANTS } from './constants';

export const validateFile = (file: File, maxFileSizeInMB: number) => {
  const maxFileSizeInBytes = maxFileSizeInMB * 1024 * 1024;

  if (file.size > maxFileSizeInBytes) {
    const fileSize = Math.round((file.size / 1024 / 1024) * 100) / 100;
    return `The file you selected is ${fileSize}MB, which is larger than ${maxFileSizeInMB}MB`;
  }

  const fileExtensionMatch = file.name.match(/\.([^.]+)$/);
  if (fileExtensionMatch) {
    const fileExtension = fileExtensionMatch[1].toUpperCase();
    if (!(OCR_CONSTANTS.FILE_EXTENSIONS as readonly string[]).includes(fileExtension)) {
      return `${fileExtension} is an invalid file type. Please select a ${OCR_CONSTANTS.FILE_EXTENSIONS.join(', ')} file.`;
    }
  }

  return null;
};

export const processImageFile = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target?.result as string;
      resolve(result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const convertCanvasToFile = (canvas: HTMLCanvasElement, filename: string = OCR_CONSTANTS.CAMERA_FILENAME): Promise<File> => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], filename, { type: OCR_CONSTANTS.MIME_TYPE_JPEG });
        resolve(file);
      }
    }, OCR_CONSTANTS.MIME_TYPE_JPEG);
  });
};

export const normalizeOcrResults = (response: any): string[] => {
  return response?.data || [];
};
